/**
 * Validate Email
 * @param string
 * @return boolean
 */
export const isValidEmail = input => {
   const regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

   return regex.test(input)
}

/**
 * Get SSN (Social Security Number) and returns true or false
 * Used this one as base: https://codepen.io/LasseStilvang/pen/WrLKbb/
 *
 * @param string
 * @return boolean
 */
export const isValidSSN = (ssn, noAgeLimit = false) => {
   const regex = /^(19|20)?(\d{6}([-+]|\s)(\d{4}|x{4}|X{4}))$/

   if (regex.test(ssn)) {
      const age = getAge(ssn)
      if (age < 16 || noAgeLimit) {
         // if the SSN has no last digits
         let lastFour = ssn.substr(ssn.length - 4)
         if (lastFour === 'xxxx' || lastFour === 'XXXX') {
            return { valid: true }
         }

         let transformedSSN = ssn
            .replace(/\D/g, '') // strip out all but digits
            .split('') // convert string to array
            .reverse() // reverse order for Luhn
            .slice(0, 10) // keep only 10 digits (i.e. 1977 becomes 77)

         // verify we got 10 digits, otherwise it is invalid
         if (transformedSSN.length !== 10) {
            return {
               valid: false,
               error:
                  'Sorry, this is personal number is not valid. (20YYMMDD-XXXX)'
            }
         }

         let sum = transformedSSN
            // convert to number
            .map(function (n) {
               return Number(n)
            })
            // perform arithmetic and return sum
            .reduce(function (previous, current, index) {
               // multiply every other number with two
               if (index % 2) current *= 2
               // if larger than 10 get sum of individual digits (also n-9)
               if (current > 9) current -= 9
               // sum it up
               return previous + current
            })
         // sum must be divisible by 10
         const validSSN = 0 === sum % 10
         if (validSSN) {
            return { valid: validSSN }
         } else {
            return {
               error: 'Sorry, this is personal number is not valid.',
               valid: false
            }
         }
      } else {
         return {
            error: 'Your child needs to be younger than 16',
            valid: false
         }
      }
   } else if (ssn !== '') {
      return {
         error: 'Sorry, this is personal number is not valid. (20YYMMDD-XXXX)',
         valid: false
      }
   }
}
const getAge = SSN => {
   const dateFromSSN = SSN.split('-')[0]
   const year = dateFromSSN.substr(0, 4)
   const month = dateFromSSN.substr(4, 2)
   const date = dateFromSSN.substr(6, 2)

   const birthday = new Date(year + '/' + month + '/' + date)
   const cur = new Date()
   const diff = cur - birthday
   const age = Math.floor(diff / 31536000000)

   return age
}
